/**
 * Field formatters registry
 * Maps field IDs to their formatter hooks
 */

import {useAdditionalNotesFormatter} from './additionalNotes.formatter'
import {useAddressFormatter} from './address.formatter'
import {useDateFormatter} from './date.formatter'
import {useDriverInstructionsFormatter} from './driverInstructions.formatter'
import {useIntervalsFormatter} from './intervals.formatter'
import {useMaterialFormatter} from './material.formatter'
import {useMaterialTestingFormatter} from './materialTesting.formatter'
import {useOrderPlacerFormatter} from './orderPlacer.formatter'
import {usePoNumberFormatter} from './poNumber.formatter'
import {useQuantityFormatter} from './quantity.formatter'
import {useRetarderFormatter} from './retarder.formatter'
import {useSiteContactFormatter} from './siteContact.formatter'
import {useStatusFormatter} from './status.formatter'
import {useTimeFormatter} from './time.formatter'
import type {FieldFormatter} from './types'
import {useUsageFormatter} from './usage.formatter'

export * from './types'
export * from './utils'

/**
 * Hook that returns a map of field formatters
 * Each formatter is a hook, so they're called here to follow Rules of Hooks
 */
export const useFieldFormatters = (): Record<string, FieldFormatter> => {
  // Call all formatter hooks (must follow Rules of Hooks)
  const materialFormatter = useMaterialFormatter()
  const usageFormatter = useUsageFormatter()
  const quantityFormatter = useQuantityFormatter()
  const intervalsFormatter = useIntervalsFormatter()
  const dateFormatter = useDateFormatter()
  const timeFormatter = useTimeFormatter()
  const materialTestingFormatter = useMaterialTestingFormatter()
  const retarderFormatter = useRetarderFormatter()
  const siteContactFormatter = useSiteContactFormatter()
  const poNumberFormatter = usePoNumberFormatter()
  const driverInstructionsFormatter = useDriverInstructionsFormatter()
  const additionalNotesFormatter = useAdditionalNotesFormatter()
  const addressFormatter = useAddressFormatter()
  const orderPlacerFormatter = useOrderPlacerFormatter()
  const statusFormatter = useStatusFormatter()

  return {
    material: materialFormatter,
    usage: usageFormatter,
    quantity: quantityFormatter,
    intervals: intervalsFormatter,
    date: dateFormatter,
    time: timeFormatter,
    materialTesting: materialTestingFormatter,
    retarder: retarderFormatter,
    siteContact: siteContactFormatter,
    poNumber: poNumberFormatter,
    driverInstructions: driverInstructionsFormatter,
    additionalNotes: additionalNotesFormatter,
    address: addressFormatter,
    orderPlacer: orderPlacerFormatter,
    status: statusFormatter
  }
}
